// LoadLine Chrome extension — public configuration.
// Extension IDs are derived from the extension's public key, so they
// are not secret. Hardcoding them avoids per-env build config.

export const EXTENSION_CONFIG = {
	EXTENSION_IDS: [
		'cpcnkckpbpefgkcilhclfdefccflgaif', // Production (Web Store)
		'jpjdnpcbgmhgeklapplbijemghlmbhge', // Development (unpacked)
	],
	EXTENSION_NAME: 'LoadLine — All-in-One Dispatch',
	STORE_URL:
		'https://chromewebstore.google.com/detail/loadline-all-in-one-dispa/cpcnkckpbpefgkcilhclfdefccflgaif',
	TIMEOUTS: {
		PING: 2000,
		CONNECT_START: 180_000, // 3 min — covers slow logins + 2FA
		DISCONNECT: 5000,
		DEFAULT: 5000,
	},
}

export default EXTENSION_CONFIG
